import React from 'react';
import './App.css';
import Quiz from './Quiz'

function App() {
  return (
    <div className="App">
      <Quiz/>
        <footer>
      For more of our work analyzing documents, check out <a href="https://fathom.info/text/" target="_blank">fathom.info/text</a> and <a href="https://fathom.info/text/" target="_blank">fathom.info/tools</a>
      </footer>
    </div>
    
  );
}

export default App;
